export default __webpack_public_path__ + "static/media/pumpkin.07883c5e.png";